import { AdminUserPermissionsEnum } from '@/lib/enum';
import { Button } from '@/components/ui/button.tsx';
import { PanelInfo } from '@/components/custom';
import { Link } from 'react-router-dom';
import routes from '@/lib/routes';
import { Shield } from 'lucide-react';

type TProps = {
	permissionsExpected?: AdminUserPermissionsEnum[];
};

const NoPermission = ({ permissionsExpected }: TProps) => {

	let description = <span>Veuillez contacter l'administrateur pour obtenir des accès.</span>;

	if (permissionsExpected && permissionsExpected.length !== 0) {
		description = (
			<>
				{description}
				<br />
				({permissionsExpected.join(', ')})
			</>
		);
	}

	return (
		<PanelInfo
			title='Accès non autorisé'
			description={description}
			className='py-10 md:py-28 border-none'
			icon={Shield}>
			<Link to={routes.nav.home}>
				<Button
					type='button'
					variant={'secondary'}>
					Retourner à l'accueil
				</Button>
			</Link>
		</PanelInfo>
	);

};

export default NoPermission;
